
















































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { Wall } from 'types'
import OzListRow, { OzListRowSeparator } from 'library/v4/components/OzListRow.vue'
import ImageThumbnail from 'library/v4/components/ImageThumbnail.vue'
import RelativeTime from 'library/v4/components/relative-time.vue'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import { __ } from 'bits/intl'

@Component({ components: { OzListRow, ImageThumbnail, RelativeTime, OzIcon, OzTextButton } })
export default class OzWallListRow extends Mixins() {
  OzTextButtonColorScheme = OzTextButtonColorScheme

  /**
   * Dark mode
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Invert colors
   */
  @Prop({ default: false }) invertColors!: boolean

  /**
   * Wall to display
   */
  @Prop({ required: true }) wall!: Wall

  /**
   * Set this to false to use normal cursor, tabindex -1 etc
   */
  @Prop({ default: true }) clickable!: boolean

  /**
   * Show the more button
   */
  @Prop({ default: false }) xMore!: boolean

  /**
   * Separator type
   */
  @Prop({ default: OzListRowSeparator.Short }) separator!: OzListRowSeparator

  get title(): string {
    return this.wall.title || __('Untitled padlet')
  }

  select(): void {
    /**
     * Select the wall.
     */
    this.$emit('select', this.wall)
  }

  more(): void {
    /**
     * View more wall actions.
     */
    this.$emit('more', this.wall)
  }
}

export { OzListRowSeparator }
